import {useActions, useGetters, useMutators, useState, loopThroughRelatedStores} from './_default';
export default {
    namespaced: true,
    state: {
        ...useState(),
        sensors: [],
        classes: {},
        filter: {},
        exportFormats: [],
        showAddress: false,
        showGraphComparison: false,
        relatedStores: [
            'history',
            'history-route',
            'history-stop',
            'history-event',
            'history-position',
            'history-arrow',
        ],
        expanded: true,
    },
    getters: {
        ...useGetters(),
        sensors: state => state.sensors,
        classes: state => state.classes,
        expanded: state => state.expanded,
        showAddress: state => state.showAddress,
        showGraphComparison: state => state.showGraphComparison,
        exportFormats: state => state.exportFormats,
    },
    mutations: {
        ...useMutators(),

        exportFormats(state, formats) {
            state.exportFormats = formats;
        },

        showAddress(state, status) {
            state.showAddress = status;
        },

        showGraphComparison(state, status) {
            state.showGraphComparison = status;
        },

        clearList(state) {
            state.list = [];
            state.sensors = [];
            state.classes = {};
        },

        sensors(state, sensors) {
            state.sensors = sensors;
        },

        classes(state, classes) {
            state.classes = classes;
        },

        expanded(state, status) {
            state.expanded = status;
        },
    },
    actions: {
        ...useActions(),
        clear({ state }) {
            loopThroughRelatedStores.call(this, state.relatedStores, [
                'clearList',
                'removeLayerGroup',
            ]);
        },

        softClear({ state }) {
            loopThroughRelatedStores.call(this, state.relatedStores, ['removeLayerGroup', 'clearHighlight']);
        },

        showInMap({ state }, layers) {
            const list = state.relatedStores.filter((name) => layers ? layers.indexOf(name) !== -1 : true);
            loopThroughRelatedStores.call(this, list, ['addLayerGroup']);
        },

        select({ state }, id) {
            state.selected = id;
        }
    },
}
